import React from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { profile } from '../data/profile';

function SocialLinks() {
  return (
    <div className="social">
      <a href={`mailto:${profile.email}`} aria-label="Email">
        <MdEmail />
      </a>
      <a href={profile.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
        <FaLinkedin />
      </a>
      <a href={profile.github} target="_blank" rel="noreferrer" aria-label="GitHub">
        <FaGithub />
      </a>
    </div>
  );
}

export default SocialLinks;
